"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var PlayerPromocodeAction = /** @class */ (function (_super) {
    __extends(PlayerPromocodeAction, _super);
    function PlayerPromocodeAction(props) {
        return _super.call(this, props) || this;
    }
    PlayerPromocodeAction.prototype.componentWillMount = function () {
        this.setState({
            promocode_code: "",
            promocode_need_amount: false,
            promocode_amount: 0,
            promocode_can_activated: false
        });
        this.doReSetRules();
    };
    PlayerPromocodeAction.prototype.doReSetRules = function () {
        this.setState({
            promocode_code_rules: { isError: false },
            promocode_amount_rules: { isError: false }
        });
    };
    PlayerPromocodeAction.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.promocode_code) || (this.state.promocode_code.length === 0)) {
            this.setState({ promocode_code_rules: { isError: true, errorMessage: "Поле [Промокод] не заполнено!" } });
            return false;
        }
        if (this.state.promocode_need_amount) {
            if ((this.state.promocode_amount <= 0) || (this.state.promocode_amount > 9999999)) {
                this.setState({
                    promocode_amount_rules: {
                        isError: true,
                        errorMessage: "Поле [сумма активации промокода] имеет недопустимое значение"
                    }
                });
                return false;
            }
        }
        return true;
    };
    PlayerPromocodeAction.prototype.OnValidateDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.DetailsPromocode({
                user_player_id: this.props.rootRecord.key,
                promo_code: this.state.promocode_code
            }, function (resp) {
                _this.setState({
                    promocode_need_amount: resp.is_need_deposit,
                    promocode_can_activated: resp.is_can_activate
                });
            });
        }
    };
    PlayerPromocodeAction.prototype.OnActivateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.ActivatePromoCode({
                user_player_id: this.props.rootRecord.key,
                promo_code: this.state.promocode_code,
                amount: this.state.promocode_amount
            }, function () {
                notificationHelper_1.default.ShowTopRightNotificationText("Промокод был успешно активирован!");
            });
        }
    };
    PlayerPromocodeAction.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerPromocodeAction.prototype.getFormTitle = function () {
        return "Активация промокода";
    };
    PlayerPromocodeAction.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Промокод:", placeholder: "Введите промокод" }, value: this.state.promocode_code, onValueChanged: function (newVal) { _this.setState({ promocode_code: newVal }); }, required: true, rules: this.state.promocode_code_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Сумма промокода:",
                    placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u0430, " + this.props.rootRecord.app_currency_title
                }, values: { min: 1, max: 999999999, value: this.state.promocode_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        promocode_amount: newVal,
                        promocode_amount_rules: { isError: false }
                    });
                }, required: this.state.promocode_need_amount, rules: this.state.promocode_amount_rules, disabled: !this.state.promocode_need_amount }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.state.promocode_can_activated, title: { btnEdit: "Активировать", btnNew: "Проверить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnValidateDataClick.bind(this), onEditClick: this.OnActivateDataClick.bind(this) })));
    };
    return PlayerPromocodeAction;
}(React.Component));
exports.default = PlayerPromocodeAction;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/promocodes/PlayerPromocodeAction.tsx
// module id = 1934
// module chunks = 0